<ap-notification
  #notificationApp
  [status]="status"
  [id]="id"
  position="bottomRight" />

<router-outlet />
<gstar-loader />
<gstar-drawer />
